import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const CopyrightSchema = BaseSchema.extend({
  text: z.string().max(255),
});

export type Copyright = z.infer<typeof CopyrightSchema>;

export const AddCopyrightSchema = z.object({
  id: z.string().uuid().nullable().optional(),
});

export const CopyrightEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: CopyrightSchema,
});

export type CopyrightEntityQueryResult = z.infer<typeof CopyrightEntityQueryResultSchema>;
